export default "__VITE_ASSET__CSC2SjSG__"